import * as THREE from "three"
import { useFrame } from "@react-three/fiber"
import { useRef, Suspense } from "react"
import { clampFrac, easeOutQuad, easeInOutQuad, easeInQuad, lerp, pinPosition } from "../util"
import useStore from "../AppStore"

export default function MovableScene(props) {
  
  const groupRef = useRef(null)

  const [a,b,c] = props.pin
  const [x1,y1,z1] = props.startPos
  const [x4,y4,z4] = props.endPos
  const [x2,y2,z2] = [lerp(x1,0,0.8),lerp(y1,0,0.8),lerp(z1,0,0.8)]
  const [x3,y3,z3] = [lerp(0,x4,0.2),lerp(0,y4,0.2),lerp(0,z4,0.2)]
  
  useFrame(({clock}) => {
    
    const top = useStore.getState().top
    const isVisible = top/10 >= a - c && top/10 < b + c
    groupRef.current.visible = isVisible
    if(!isVisible) return

    const scale = clampFrac(top/10, a-c, a-c/2)

    groupRef.current.scale.x = scale
    groupRef.current.scale.y = scale
    groupRef.current.scale.z = scale

    let x, y, z
    const t = clampFrac(top/10, a-c, b+c)
    if(t < 0.15){
      const tt = easeOutQuad(t/0.15)
      x = lerp(x1,x2,tt)
      y = lerp(y1,y2,tt)
      z = lerp(z1,z2,tt)
    }
    else if(t > 0.85){
      const tt = easeInQuad((t-0.85)/0.15)
      x = lerp(x3,x4,tt)
      y = lerp(y3,y4,tt)
      z = lerp(z3,z4,tt)
    }
    else {
      const tt = clampFrac(t,0.15,0.85)
      x = lerp(x2,x3,tt)
      y = lerp(y2,y3,tt)
      z = lerp(z2,z3,tt)
    }
    groupRef.current.position.x = x
    groupRef.current.position.y = y
    groupRef.current.position.z = z
  })
  
  return(
    <group ref={groupRef} {...props}>
      {props.children}
    </group>
  )
}